import { Button, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const IAButton = styled(Button)`
  background: ${({ theme }) =>
    `linear-gradient(304deg, ${getThemeColor('secondary', theme)} -1.45%, ${getThemeColor('primary', theme)} 103.12%);`};
  gap: 12px;
`
